import { RouteObject } from "react-router-dom";
import PaymentLanding from "./components/landing/landing";
import StripeLanding from "./stripe/components/landing/landing";
import DokuLanding from "./doku/components/landing/landing";
import CreateUsPaymentIntegration from "./components/UsPayment/create/create";
import UsPaymentDetailLanding from "./components/UsPayment/detail/landing/landing";

export interface PaymentRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: PaymentRoute[];
}

// Keeping routes flat and simple as requested
export const ixPaymentRoutes: PaymentRoute[] = [
  {
    path: "/integration-hub/payments",
    element: <PaymentLanding />,
  },
  {
    path: "/integration-hub/payments/stripe/configure",
    element: <StripeLanding />,
  },
  {
    path: "/integration-hub/payments/doku/configure",
    element: <DokuLanding />,
  },
  {
    path: "/payments/:paymentType/:action",
    element: <CreateUsPaymentIntegration />,
  },
  {
    path: "/payments/:paymentType/:action/:id",
    element: <CreateUsPaymentIntegration />,
  },
  {
    path: "/payments/:paymentType/details/:id?",
    element: <UsPaymentDetailLanding />,
  },
];
